/* tslint:disable */
import {
  Institutions,
  PopulationCategory
} from '../index';

declare var Object: any;
export interface PopulationCountInterface {
  "count": number;
  "year": number;
  "id"?: number;
  "institution_id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  "population_category_id"?: number;
  populationCount?: Institutions;
  populationCategory?: PopulationCategory;
}

export class PopulationCount implements PopulationCountInterface {
  "count": number;
  "year": number;
  "id": number;
  "institution_id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  "population_category_id": number;
  populationCount: Institutions;
  populationCategory: PopulationCategory;
  constructor(data?: PopulationCountInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `PopulationCount`.
   */
  public static getModelName() {
    return "PopulationCount";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of PopulationCount for dynamic purposes.
  **/
  public static factory(data: PopulationCountInterface): PopulationCount{
    return new PopulationCount(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'PopulationCount',
      plural: 'PopulationCounts',
      path: 'PopulationCounts',
      properties: {
        "count": {
          name: 'count',
          type: 'number'
        },
        "year": {
          name: 'year',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "institution_id": {
          name: 'institution_id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
        "population_category_id": {
          name: 'population_category_id',
          type: 'number'
        },
      },
      relations: {
        populationCount: {
          name: 'populationCount',
          type: 'Institutions',
          model: 'Institutions'
        },
        populationCategory: {
          name: 'populationCategory',
          type: 'PopulationCategory',
          model: 'PopulationCategory'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/theme/services/sdk/models/PopulationCount.ts